export interface ClientNoteFormValues {
  note: string | null;
}

export const ClientNoteMaxLength = {
  note: 50000,
};
